// src/data/contentPartners.js
//
// Third parties who produce content for a section of the platform and are
// credited on it ("Powered by …"). A data module, like editions: swapping or
// adding a partner is an edit here, never a component fork.
//
// Finance is the first. Scotiabank and Scotia Wealth Management author the
// Financial Wellbeing library; the section carries their mark and their
// disclaimer. logoUrl is a slot — the lockup renders the names as text until
// the approved asset lands, and falls back to text again if the image fails.
//
// Two things a bank's brand team will almost certainly weigh in on before
// launch, both of which are one-line edits here: the exact lockup wording
// ("Powered by Scotia" vs their approved co-brand line) and the disclaimer,
// which for a regulated institution is usually supplied verbatim.

export const CONTENT_PARTNERS = {
    finance: {
        id: 'scotia',
        name: 'Scotiabank',
        coName: 'Scotia Wealth Management',
        shortName: 'Scotia',
        poweredBy: 'Powered by Scotia',
        // Served from public/partners/ (trimmed; originals in assets-src/partners/).
        // Both are red-on-white wordmarks, so the lockup keeps a white tile.
        logoUrl: '/partners/scotiabank.png',
        coLogoUrl: '/partners/scotia-wealth-management.png',
        url: '',
        // Scotia Red is the documented brand primary; dark/light are derived for
        // the hero gradient and icon tiles. Applied as inline styles by the hub
        // so a partner swap never depends on Tailwind having seen the hex.
        colors: { primary: '#EC111A', dark: '#8A0B11', light: '#FDECED' },
        tagline: 'Practical money guidance from Scotiabank and Scotia Wealth Management.',
        disclaimer:
            'This content is for general education only and is not personalized financial, ' +
            'investment, tax or legal advice. Consider your own situation, and speak with a ' +
            'qualified advisor before making financial decisions.'
    }
};

export const getContentPartner = (key) => CONTENT_PARTNERS[key] || null;
